import { Heading, Spacer, mediaMixin, spaceMixin } from '@zillow/constellation';
import { cmsReducers } from '@zillow/zhl-redux-commons';
import { trackEvent } from '@zillow/universal-analytics';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import UpsellGroup from '../../UpsellGroup/UpsellGroup';
import { ExplicitLoanTypeCard, StyledLoanTypeCard } from './LoanTypeCard';

const { conventionalSamples, vaSamples, fhaSamples } = cmsReducers.CMS_DOCUMENT_IDS;
const options = [
    {
        key: 'conventional',
        title: 'Conventional loan',
        description: 'Wide range of options to suit many unique needs.',
        downPayment: '3%',
        points: ['Fixed-rate options', '15-, 20-, or 30-year terms offered', 'PMI required with <20% down'],
        terms: conventionalSamples,
    },
    {
        key: 'va',
        title: 'VA loan',
        downPayment: '0%',
        description: 'No down payment and no PMI required for qualified veterans.',
        points: ['Competitive interest rates', 'Reduced closing costs', 'No PMI'],
        terms: vaSamples,
    },
    {
        key: 'fha',
        title: 'FHA loan',
        downPayment: '3.5%',
        description: 'Great for first-time buyers or buyers with lower credit scores.',
        points: ['Popular with first-time buyers', 'Flexible credit requirements', 'Mortgage insurance is required'],
        terms: fhaSamples,
    },
];
const StyledIntro = styled(Heading)`
    text-align: center;
    margin-bottom: ${spaceMixin('lg')};
    padding: 0 ${spaceMixin('md')};
    ${mediaMixin(
        'md',
        css`
            padding-top: ${spaceMixin('xl')};
        `
    )}
`;
const StyledLoanComparison = styled.div`
    padding-bottom: ${spaceMixin('md')};
    width: 100%;
    ${StyledLoanTypeCard} {
        flex-basis: 98%;
    }
    ${StyledLoanTypeCard} + ${StyledLoanTypeCard} {
        margin-top: ${spaceMixin('sm')};
    }
    ${mediaMixin(
        'md',
        css`
            ${StyledLoanTypeCard} {
                flex-basis: 49%; // Guarantee shrink/grow
                max-width: 49%;
            }
            ${StyledLoanTypeCard}:nth-of-type(n + 1) {
                margin-top: ${spaceMixin('sm')};
            }
        `
    )}
    ${mediaMixin(
        'xl',
        css`
            ${StyledLoanTypeCard} {
                flex-basis: 24%; // Guarantee shrink/grow
                max-width: 24%;
            }
            ${StyledLoanTypeCard} {
                margin-top: 0;
            }
        `
    )};
`;
const StyledCardContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 0 ${spaceMixin('lg')} ${spaceMixin('sm')} ${spaceMixin('lg')};
`;
const LoanTypeComparison = ({ fetchMarkdownDocument, cms }) => (
    <StyledLoanComparison>
        <StyledIntro level="3" serif>
            One experienced team. Plenty of options.
        </StyledIntro>
        <StyledCardContainer>
            {options.map(option => (
                <ExplicitLoanTypeCard
                    {...option}
                    fetchTerms={() => fetchMarkdownDocument(option.terms)}
                    terms={cms && cms[option.terms]}
                />
            ))}
        </StyledCardContainer>
        <Spacer marginLeft="lg" marginRight="lg" marginBottom="sm" />
        <UpsellGroup
            text="The right loan is out there. We'll help you find it."
            onCTA={() => {
                trackEvent({
                    category: 'Home Page',
                    action: 'Get Started Button Click',
                    label: 'Button 4',
                });
            }}
            ctaText="Get started"
        />
    </StyledLoanComparison>
);
LoanTypeComparison.propTypes = {
    fetchMarkdownDocument: PropTypes.func,
    cms: PropTypes.object,
};
export default LoanTypeComparison;
